export default `<!DOCTYPE html>
<html>
  <head>
    <title>Certificado</title>
    <style type="text/css">
      body {
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: center;
        justify-content: center;
        font-family: "Arial";
      }

      td {
        padding-left: 10px;
        width: 50%;
      }

      table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        overflow: hidden;
        page-break-after: avoid;
        page-break-before: avoid;
        page-break-inside: avoid;
      }

      th, tr {
        width:50%;
      }

      tr {
        margin-top: 4px;
      }

      tr:nth-child(odd) {
        background-color: #f2f2f2 !important;
      }

      th {
        text-align: left;
        background-color: #fff;
        padding: 20px 10px 10px 10px;
      }

      .container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
      }

      p {
        font-size: 0.8rem;
        text-align: center;
      }

      b {
        font-size: 0.8rem;
        text-align: right;
        margin-right: 5px;
        align-self: center;
      }

      .name {
        font-size: 3rem;
        font-style: italic;
        margin-bottom: 30px;
        margin-top: 20px;
      }

      .row {
        display: flex;
        flex-direction: row;
        flex: 1;
        padding-left: 20px;
        align-items: center;
        justify-content: flex-start;
      }

      .row-logos {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        flex: 1;
        width: 100%;
        margin-top: 50px;
        align-items: center;
      }

      .row-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        align-self: center;
        flex: 1;
        width: 98%;
        border-bottom-left-radius: 45px;
        border-bottom-right-radius: 45px;
        margin-right: 10px;
        margin-left: 10px;
        padding-bottom: 15px;
        padding-right: 15px;
        padding-left: 15px;
        border-bottom: 1px solid rgba(0,0,0,0.3);
        border-right: 1px solid rgba(0,0,0,0.2);
        border-left: 1px solid rgba(0,0,0,0.2);
      }

      .signature {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .table-div {
        overflow: auto;
      }

      .text-group {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 1;
        width: 100%;
        margin-top: 20px;
      }

      .text-group-data {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 100%;
        line-height: 1px;
        align-items: flex-start;
      }

      .top-date {
        display: flex;
        flex-direction: row;
        border: 1px solid lightgray;
        border-radius: 25px;
        height: 30px;
        align-self: center;
        justify-content: center;
        align-items: center;
        padding: 0 10px 0 10px;
      }

      .logo {
        width: 200px;
        height: auto;
        border-bottom: 1px solid black;
      }

      .quiz-title {
        margin-bottom: 10px;
      }

    </style>
  </head>
  <body>
    <div class="container">
      <div class="row-header">
        <img
          class="logo-smartcoop"
          src="data:image/png;base64,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"
        />
        <p>
          {quizName}
        </p>
        <p>
          {currentDate}
        </p>
      </div>
      <div class="text-group-data">
        <div class="row">
          <b class="fullwidth">PRODUTOR: </b>
          <p class="fullwidth">{producerName}</p>
        </div>
        <div class="row">
          <b class="fullwidth text-end">INSCRIÇÃO ESTADUAL: </b>
          <p class="fullwidth">{stateRegisterment}</p>
        </div>
        <div class="row">
          <b class="fullwidth text-end">TÉCNICO: </b>
          <p class="fullwidth">{technicalName}</p>
        </div>
        <div class="row">
          <b class="fullwidth text-end">COOPERATIVA: </b>
          <p class="fullwidth">{organizationName}</p>
        </div>
        <div class="row">
          <b class="fullwidth text-end">CIDADE:</b>
          <p class="fullwidth">{city}</p>
        </div>
      </div>

      <b class="quiz-title">{quizName} ({createdAt})</b>
        {tableData}
      <div class="row-logos">
        {signatures}
      </div>
    </div>
  </body>
</html>
`
